
let _this;
import manual from './manual.vue'
import recurring from './recurring.vue'
import videoDownload from './videoDownload.vue'
export default {
  name: "download_center",
  components: {
    manual,recurring,videoDownload
  },
  data() {
    _this = this;
    // 用户类型权限列表与权限数组对应
    const reportUserTypeList = {
      recurring:'M_RecurringReport',
      manual: 'M_ManuallyGenerated',
    }
    // 判断用户是否有该权限
    let findIndex = 3
    Object.keys(reportUserTypeList).forEach((key,index) =>{
       if(_this.$root.adminInfo.permissionCodes.indexOf(reportUserTypeList[key]) !== -1){
        if(findIndex === 3){
          findIndex = index+1
        }
      }
    })
    return {
      defaultIndex: findIndex,
      tabIndex: findIndex,
      loadCenterModal:false,
    }
  },
  mounted() {
    _this = this;
  },
  methods: {
    openLoadCenter: function () {
      _this.tabIndex = _this.defaultIndex
      _this.loadCenterModal = true;
    },
    changeTabs:function (index) {
      this.tabIndex = index;
    },
    jumpToReport:function (type) {
      if(type === 1 && _this.$route.path!== '/recurring'){
        _this.$router.push('recurring')
      }else if( type === 2 && _this.$route.path!== '/manuallyGenerated'){
        _this.$router.push('manuallyGenerated')
      }else if(type === 3 && _this.$route.path!== '/ideoDownloadCenter'){
        _this.$router.push('ideoDownloadCenter')
      }
      _this.loadCenterModal = false ;
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/downloadCenters/downloadCenter.js